import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { AdvancedAnalysisField } from "../models/AdvancedAnalysisField";
import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { AdvancedAnalysisFieldType } from "../models/AdvancedAnalysisFieldType";
import { JsonEditorSchemaType } from "@/shared/JsonEditorSchema/models/JsonEditorCdnSchemaType";


export type AdvancedAnalysisJsonEditorType = JsonEditorType;

export type AdvancedAnalysisJsonEditorSchema = JsonEditorSchema;

export class AdvancedAnalysisJsonConfigurationService {

    public static getJsonEditorSchemaForField(field: AdvancedAnalysisField): AdvancedAnalysisJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: AdvancedAnalysisJsonEditorSchema = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: AdvancedAnalysisJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: AdvancedAnalysisFieldType | JsonEditorSchemaType | any): AdvancedAnalysisJsonEditorType | null {

        switch (fieldType) {
            case AdvancedAnalysisFieldType.Text:
                return 'string';
            case AdvancedAnalysisFieldType.Number:
                return 'number';
            case AdvancedAnalysisFieldType.Boolean:
                return 'boolean';
            case AdvancedAnalysisFieldType.Array:
            case AdvancedAnalysisFieldType.ArrayValues:
                return 'array';
            case AdvancedAnalysisFieldType.Object:
            case AdvancedAnalysisFieldType.Json:
            case JsonEditorSchemaType.RuleSchema:
            case JsonEditorSchemaType.AnalysisConfigSchema:
            case JsonEditorSchemaType.CalculationSchema:
            case JsonEditorSchemaType.PlotSchema:
            case JsonEditorSchemaType.TableSchema:
            case JsonEditorSchemaType.CustomReportSchema:
                return 'object';
            default:
                return null; // Do not limit the schema.type for unknown types, useful for fields without a valid type defined
        }

    }

    public static getJsonEditorSchemaForAdvancedAnalysis(): AdvancedAnalysisJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }

}
